module.exports = __webpack_public_path__ + "static/media/catAeromall.370d4768.jpg";